import React, { useState } from "react";

import {
    Box,
    Typography,
    Modal,
    TextField,
    Button,
    Stack,
    Snackbar,
    Alert,
    IconButton,
} from "@mui/material";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

// API

export default function UnsubscribeModal({
    open,
    onClose,
}) {
    const [email, setEmail] = useState("");

    const [loading, setLoading] =
        useState(false);

    const [snackbar, setSnackbar] =
        useState(false);

    const handleSubmit = async () => {
        try {
            if (!email) {
                alert(
                    "Please enter email"
                );
                return;
            }
            setLoading(true);
            await axios.post("https://dev.ienergydigital.com/task-api/api/email-suits/unsubscribe",
                { email },
            );
            setSnackbar(true);
            setEmail("");
            onClose();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform:
                            "translate(-50%, -50%)",

                        width: {
                            xs: "92%",
                            sm: 560,
                        },

                        borderRadius: "28px",

                        overflow: "hidden",

                        background:
                            "radial-gradient(circle at center, rgba(67,97,238,0.35) 0%, #020617 65%)",

                        border:
                            "1px solid rgba(255,255,255,0.08)",

                        boxShadow:
                            "0 20px 80px rgba(0,0,0,0.45)",

                        p: {
                            xs: 3,
                            md: 5,
                        },

                        color: "#fff",
                    }}
                >
                    {/* CLOSE */}

                    <IconButton
                        onClick={onClose}
                        sx={{
                            position:
                                "absolute",
                            top: 14,
                            right: 14,
                            color:
                                "rgba(255,255,255,0.7)",
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* TITLE */}

                    <Typography
                        fontSize={{
                            xs: "34px",
                            md: "48px",
                        }}
                        fontWeight={800}
                        textAlign="center"
                        lineHeight={1.1}
                        mb={2}
                        sx={{
                            background:
                                "linear-gradient(90deg,#6C63FF,#3B82F6)",

                            WebkitBackgroundClip:
                                "text",

                            WebkitTextFillColor:
                                "transparent",
                        }}
                    >
                        Unsubscribe
                    </Typography>

                    {/* SUBTITLE */}

                    <Typography
                        textAlign="center"
                        fontSize="18px"
                        color="rgba(255,255,255,0.7)"
                        mb={4}
                    >
                        Enter your email to
                        unsubscribe from future
                        newsletters and updates.
                    </Typography>

                    {/* INPUT */}

                    <Stack
                        direction={{
                            xs: "column",
                            sm: "row",
                        }}
                        spacing={2}
                    >
                        <Box
                            sx={{
                                flex: 1,
                                position:
                                    "relative",
                            }}
                        >
                            <EmailOutlinedIcon
                                sx={{
                                    position:
                                        "absolute",
                                    top: "50%",
                                    left: 16,
                                    transform:
                                        "translateY(-50%)",

                                    color:
                                        "#818CF8",

                                    zIndex: 2,
                                }}
                            />

                            <TextField
                                fullWidth
                                placeholder="Enter your email"
                                value={email}
                                onChange={(e) =>
                                    setEmail(
                                        e.target
                                            .value
                                    )
                                }
                                sx={{
                                    "& .MuiOutlinedInput-root":
                                    {
                                        height: 60,

                                        borderRadius:
                                            "18px",

                                        background:
                                            "rgba(255,255,255,0.06)",

                                        backdropFilter:
                                            "blur(16px)",

                                        color:
                                            "#fff",

                                        pl: 4,

                                        "& fieldset":
                                        {
                                            border:
                                                "1px solid rgba(255,255,255,0.08)",
                                        },

                                        "&:hover fieldset":
                                        {
                                            border:
                                                "1px solid rgba(99,102,241,0.4)",
                                        },

                                        "&.Mui-focused fieldset":
                                        {
                                            border:
                                                "1px solid #6366F1",
                                        },

                                    },

                                    "& input:-webkit-autofill": {
                                        WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
                                        WebkitTextFillColor: "#fff",
                                        caretColor: "#fff",
                                        borderRadius: "12px",
                                        transition: "background-color 5000s ease-in-out 0s",
                                    },

                                    "& input:-webkit-autofill:hover": {
                                        WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
                                        WebkitTextFillColor: "#fff",
                                    },

                                    "& input:-webkit-autofill:focus": {
                                        WebkitBoxShadow: "0 0 0 100px rgba(255,255,255,0.03) inset",
                                        WebkitTextFillColor: "#fff",
                                    },

                                    "& input": {
                                        color:
                                            "#fff",
                                    },

                                    "& input::placeholder":
                                    {
                                        color:
                                            "rgba(255,255,255,0.55)",

                                        opacity: 1,
                                    },
                                }}
                            />
                        </Box>

                        {/* BUTTON */}

                        <Button
                            variant="contained"
                            onClick={
                                handleSubmit
                            }
                            disabled={loading}
                            sx={{
                                minWidth: 160,
                                height: 60,

                                borderRadius:
                                    "18px",

                                textTransform:
                                    "none",

                                fontWeight: 700,

                                fontSize: "15px",

                                background:
                                    "linear-gradient(135deg,#1D4ED8 0%,#2563EB 100%)",

                                boxShadow:
                                    "none",

                                "&:hover": {
                                    background:
                                        "linear-gradient(135deg,#1E40AF 0%,#1D4ED8 100%)",
                                },
                            }}
                        >
                            {loading
                                ? "Submitting..."
                                : "Unsubscribe"}
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            {/* SNACKBAR */}

            <Snackbar
                open={snackbar}
                autoHideDuration={7000}
                onClose={() =>
                    setSnackbar(false)
                }
                anchorOrigin={{
                    vertical: "top",
                    horizontal:
                        "center",
                }}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    onClose={() =>
                        setSnackbar(false)
                    }
                    sx={{
                        width: "100%",
                        borderRadius:
                            "12px",
                        alignItems:
                            "center",
                    }}
                >
                    You have been
                    successfully
                    unsubscribed from
                    future newsletters.
                    If you still receive
                    an email, write to
                    us at
                    zero@ienergy.ai
                </Alert>
            </Snackbar>
        </>
    );
}